import Widget from 'app/components/common/Widget';
import { useStore } from 'app/context';
import { NachfolgePlanungVm } from 'app/stores/ui/nachfolgeplanung.ui.store';
import { formatNum } from 'app/utils';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';

interface DataRowProps {
	label: string;
	ziel?: string | number;
	ergebnis?: string | number;
	ze?: string | number;
}

const DataRow = ({ label, ziel, ergebnis, ze }: DataRowProps) => (
	<tr>
		<td>{label}</td>
		<td className="has-text-right">{ziel ?? '-'}</td>
		<td className="has-text-right">{ergebnis ?? '-'}</td>
		<td className="has-text-right">{ze ?? '-'}</td>
	</tr>
);

interface AgtNachfolgePlanungBestandBewertungProps {
	agtId: number;
	vorJahr: number;
}

export const AgtNachfolgePlanungBestandBewertung = observer(({ agtId, vorJahr }: AgtNachfolgePlanungBestandBewertungProps) => {
	const { nachfolgeplanungUiStore } = useStore();
	const [vm, setVm] = useState<NachfolgePlanungVm | null>(null);

	useEffect(() => {
		nachfolgeplanungUiStore.load().then(() => {
			const found = nachfolgeplanungUiStore.items.find((item) => item.agtId === agtId);
			setVm(found || null);
		});
	}, [agtId, nachfolgeplanungUiStore]);

	if (!vm) {
		return null;
	}

	return (
		<div className="table-container is-boxed">
			<table className="table">
				<thead>
					<tr>
						<th>{`Bestand und Bewertung ${vorJahr}`}</th>
						<th className="has-text-right">Ziel</th>
						<th className="has-text-right">Ergebnis</th>
						<th className="has-text-right">ZE</th>
					</tr>
				</thead>
				<tbody>
					<DataRow
						label="Bestand Sach Gesamt"
						ziel={formatNum(120000)}
						ergebnis={formatNum(vm.bestandSachVJ)}
						ze={vm.bestandSachVJ > 0 ? `${Math.round((vm.bestandSachVJ / 120000) * 100)} %` : '-'}
					/>
					<DataRow label="Bestandszuwachs Sach" ziel={formatNum(440)} ergebnis={formatNum(394)} ze="90 %" />
					<DataRow label="Bestandszuwachs Sach %" ziel={formatNum(900)} ergebnis={formatNum(995)} ze="132 %" />
					<DataRow
						label="Bewertung"
						ziel={formatNum(50)}
						ergebnis={formatNum(vm.gesamtbewertungVJ)}
						ze={vm.gesamtbewertungVJ > 0 ? `${Math.round((vm.gesamtbewertungVJ / 50) * 100)} %` : '-'}
					/>
				</tbody>
			</table>
		</div>
	);
});
